import appearanceTemplate from './appearance.html';

export default angular
  .module('main.organizations.edit.tabs.appearance', [])

  .directive('editOrganizationAppearanceTab', () => {
    return {
      restrict: 'E',
      template: appearanceTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $filter,
                   utils,
                   config,
                   ToastsService,
                   EditOrganizationDataProvider) => {
        const $t = $filter('translate');
        const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';

        $scope.selectedOrganization = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
        $scope.dataProvider = EditOrganizationDataProvider.instance;

        angular.extend($scope, {
          removeLogo: removeLogo,
          resetColors: resetColors,
          updateLogo: updateLogo,
          defaultColors: true,
          helpers: {},
          minicolorSetting: {
            control: 'hue',
            theme: 'maestro',
            position: 'bottom left',
            hide: function() {
              saveColors();
            }
          },
        });

        init();

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.organizationResource.init(),
            $scope.dataProvider.organizationPropsResource.init(),
          ])
            .then(() => {
              initOrganizationAppearance();
              initWatchers();
              $scope.loading = false;
            }, () => {
              $scope.loading = false;
            });
        }

        function initOrganizationAppearance() {
          $scope.helpers.colors = config.getConfigByKey('orgColors');
          $scope.organization = angular.copy($scope.dataProvider.organizationResource.value);
          $scope.orgProperties = angular.copy($scope.dataProvider.organizationPropsResource.value);

          // Organization colors
          for (let color of $scope.helpers.colors) {
            let val = getPropertyByName($scope.orgProperties, color.name);
            if (val != null) {
              color.value = val;
            }
          }

          // Backup colors
          $scope.helpers.colorsBackup = angular.copy($scope.helpers.colors);
          $scope.defaultColors = compareDefaultColors($scope.helpers.colorsBackup);

          // Organization logos
          let logoPropsObj = {};
          let logoProps = ['logo', 'logoLight', 'logoDark'];
          logoProps.forEach((el) => {
            let fileContent = $filter('filter')($scope.orgProperties, { 'name': el }, true);
            let exist = !!fileContent && fileContent.length > 0;
            logoPropsObj[el] = {
              exist: exist,
              parent: exist && !!fileContent[0].parent,
            };
          });
          $scope.customLogos = angular.copy(logoPropsObj);

          utils.getWebappHostUrl()
            .then(url => {
              let baseUrl = `${url}/admin/json/organizations/${$scope.organization.id}/objects/`;
              $('#imgLogo').attr('src', `${baseUrl}logo?ts=${new Date().getTime()}`);
              $('#imgLogoLight').attr('src', `${baseUrl}logoLight?ts=${new Date().getTime()}`);
              $('#imgLogoDark').attr('src', `${baseUrl}logoDark?ts=${new Date().getTime()}`);
            });
        }

        function initWatchers() {
          $scope.$watch('helpers.colorsBackup', (newValue, oldValue) => {
            if (newValue.length && oldValue.length) {
              let result = newValue.filter(el => !oldValue.find(c => c.value === el.value)).map(c => c.value);
              if (result.length) { // some changes detected
                $scope.defaultColors = compareDefaultColors(newValue);
              }
            }
          });
        }

        /**
         * Compare colors with defaults
         * @param {*} colors
         * @returns {boolean}
         */
        function compareDefaultColors(colors) {
          let defaultColors = config.getConfigByKey('orgColors');
          let compare = colors.filter(el => !defaultColors.find(c => c.value === el.value)).map(c => c.value);
          return !compare.length;
        }

        function removeLogo($flow, logoType) {
          let propertyName = 'logo';
          if (logoType) {
            propertyName = logoType === 'light' ? 'logoLight' : 'logoDark';
          }

          return $scope.dataProvider.deleteOrganizationObject(propertyName)
            .then(() => {
              $scope.customLogos[propertyName].exist = false;
              $flow.files = [];
              if (!logoType) {
                utils.updateLogo();
              }

              let elementId = '#imgLogo';
              if (logoType) {
                elementId = logoType === 'light' ? '#imgLogoLight' : '#imgLogoDark';
              }
              $(elementId).attr('src', '/assets/images/care-daily-logo.png');

              initOrganizationAppearance();
              ToastsService.success(null, $t('orgs.new.messages.remove-success'));
            }, (err) => {
              if (err.resultCode === 6) {
                ToastsService.info(null, $t('orgs.new.messages.not-found-logo'));
              } else {
                handleError(err);
              }
            });
        }

        function saveColors() {
          let newColors = [];

          for (let i = 0; i < $scope.helpers.colors.length; i++) {
            let color = $scope.helpers.colors[i];
            let colorOrigin = $scope.helpers.colorsBackup[i];
            if (color.value !== colorOrigin.value) {
              newColors.push(color);
            }
          }

          if (newColors && newColors.length > 0) {
            $scope.loading = true;
            return saveOrgProperties(newColors)
              .then(() => {
                // Backup colors
                $scope.helpers.colorsBackup = angular.copy($scope.helpers.colors);

                ToastsService.success(null, $t('settings.save-colors-success'));
                $scope.loading = false;
                if ($scope.organization.id === $scope.selectedOrganization.id) {
                  utils.updateOrgCssFile($scope.helpers.colorsBackup);
                }
              }, (err) => {
                $scope.loading = false;
                $scope.helpers.colors = angular.copy($scope.helpers.colorsBackup);
                handleError(err);
              });
          }
        }

        function resetColors() {
          $scope.loading = true;
          $scope.helpers.colors = config.getConfigByKey('orgColors');
          return saveOrgProperties($scope.helpers.colors)
            .then(() => {
              // Backup colors
              $scope.helpers.colorsBackup = angular.copy($scope.helpers.colors);

              ToastsService.success(null, $t('settings.save-colors-success'));
              $scope.loading = false;
              if ($scope.organization.id === $scope.selectedOrganization.id) {
                utils.updateOrgCssFile($scope.helpers.colorsBackup);
              }
            }, (err) => {
              $scope.loading = false;
              $scope.helpers.colors = angular.copy($scope.helpers.colorsBackup);
              handleError(err);
            });
        }

        function getPropertyByName(orgProperties, name) {
          return utils.getPropertyByName(orgProperties, name, true);
        }

        function updateLogo($files, $event, $flow, logoType) {
          $scope.updateLogoSuccess = false;
          $scope.updateLogoError = false;
          $scope.fileTypeError = false;
          if ($files.length === 0) { //not allow file type selected.
            $scope.fileTypeError = true;
            return;
          } else {
            $scope.fileTypeError = false;
          }

          let logoProperty = 'logo';
          if (logoType) {
            logoProperty = logoType === 'light' ? 'logoLight' : 'logoDark';
          }

          let type = $files[0].getType();
          let fileType = type ? 'image/' + type : 'image/png';

          return $scope.dataProvider.uploadOrganizationObject($files[0].file, logoProperty, fileType)
            .then(() => {
              // Update visual element only for currently selected organization
              if ($scope.organization.id === $scope.selectedOrganization.id) {
                utils.getOrganizationLogoPath($scope.organization.id)
                  .then((logoPath) => {
                    utils.updateLogo(logoPath);
                  });
              }
              initOrganizationAppearance();
              ToastsService.success(null, $t('orgs.new.messages.update-success'));
            });
        }

        function saveOrgProperties(props) {
          return $scope.dataProvider.saveOrganizationProps(props)
            .then(() => {
              initOrganizationAppearance();
            })
            .catch((err) => {
              $scope.loading = false;
              return utils.handleApiError(err);
            });
        }

        /**
         * Handle error and stop loading
         */
        function handleError(err) {
          $scope.loading = false;
          return utils.handleApiError(err);
        }

      }
    };
  })
  .name;
